﻿import React, { useState, useEffect } from 'react';
import { HplcBenchSheetDetector } from '../models/hplc-bench-sheet-detector';
import { NumberBoxComponent } from './NumberBoxComponent';
import { ItemBasicInformation } from '../models/item-basic-information';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { HplcBenchSheetDetectorSignal } from '../models/hplc-bench-sheet-detector-signal';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 1;

export interface Props {
    hplcBenchSheetDetectorId: string;
    isReadOnly?: boolean;
    onDetectorDeleted?: () => void;
}

export default function HplcInstrumentType2Component(props: Props) {
    const [detector, setDetector] =
        useState<HplcBenchSheetDetector>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.hplcBenchSheetDetectorId]);

    key++;

    let signals = detector && detector.type2Signals;

    return (
        <div className="pw-form-section">
            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <div className="pw-form-unit-label">Detector</div>
                    <div className="pw-readonly-label">{detector && detector.detectorType ?
                        detector.detectorType.name : 'NA'}</div>
                </div>
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <label className="pw-form-unit-label">Reference</label>
                    <NumberBoxComponent id="0" format="#" readOnly={props.isReadOnly}
                        fixedUnit='nm' onValueChanged={onValueChanged}
                        value={signals && signals.reference ? signals.reference : undefined} />
                </div>

                <div className="delete-detector-container pw-margin-right-1">
                    <Button className="title-bar-button"
                        text="" icon="info" type="success"
                        hint="item information"
                        onClick={onShowInformationDialogClick} />
                    <Button className="pw-margin-left-05"
                        onClick={onDeleteDetectorClick}
                        text="" icon="trash" />
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <label className="pw-form-unit-label">Signal A</label>
                    <NumberBoxComponent id="1" format="#" readOnly={props.isReadOnly}
                        fixedUnit='nm' onValueChanged={onValueChanged}
                        value={signals && signals.signalA ? signals.signalA : undefined} />
                </div>
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <label className="pw-form-unit-label">Signal B</label>
                    <NumberBoxComponent id="2" format="#" readOnly={props.isReadOnly}
                        fixedUnit='nm' onValueChanged={onValueChanged}
                        value={signals && signals.signalB ? signals.signalB : undefined} />
                </div>
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <label className="pw-form-unit-label">Signal C</label>
                    <NumberBoxComponent id="3" format="#" readOnly={props.isReadOnly}
                        fixedUnit='nm' onValueChanged={onValueChanged}
                        value={signals && signals.signalC ? signals.signalC : undefined} />
                </div>
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <label className="pw-form-unit-label">Signal D</label>
                    <NumberBoxComponent id="4" format="#" readOnly={props.isReadOnly}
                        fixedUnit='nm' onValueChanged={onValueChanged}
                        value={signals && signals.signalD ? signals.signalD : undefined} />
                </div>
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <label className="pw-form-unit-label">Signal E</label>
                    <NumberBoxComponent id="5" format="#" readOnly={props.isReadOnly}
                        fixedUnit='nm' onValueChanged={onValueChanged}
                        value={signals && signals.signalE ? signals.signalE : undefined} />
                </div>
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <label className="pw-form-unit-label">Signal F</label>
                    <NumberBoxComponent id="6" format="#" readOnly={props.isReadOnly}
                        fixedUnit='nm' onValueChanged={onValueChanged}
                        value={signals && signals.signalF ? signals.signalF : undefined} />
                </div>
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <label className="pw-form-unit-label">Signal G</label>
                    <NumberBoxComponent id="7" format="#" readOnly={props.isReadOnly}
                        fixedUnit='nm' onValueChanged={onValueChanged}
                        value={signals && signals.signalG ? signals.signalG : undefined} />
                </div>
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <label className="pw-form-unit-label">Signal H</label>
                    <NumberBoxComponent id="8" format="#" readOnly={props.isReadOnly}
                        fixedUnit='nm' onValueChanged={onValueChanged}
                        value={signals && signals.signalH ? signals.signalH : undefined} />
                </div>

                {itemBasicInformationDialogVisible &&
                    <DialogPopup visible={itemBasicInformationDialogVisible}
                        onHiding={hideItemBasicInformationDialog}
                        title="Item Basic Information"
                        width={'25rem'}
                        height={'21rem'}
                        dragEnabled={false}
                        resizeEnabled={false}>
                        <ItemBasicInformationDialog initInformation={itemBasicInformation}
                            onOkClick={hideItemBasicInformationDialog}
                            key={`IBI${key}`} />
                    </DialogPopup>
                }
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    async function onValueChanged(e: any) {
        if (!e.event)
            return;

        if (!detector)
            return;

        if (e.event.data && e.event.data.prop && detector &&
            detector.signals && detector.signals.length > 0) {

            const signalIdx = parseInt(e.event.data.prop);

            let editedSignals = [...detector.signals];
            let editedSignal: HplcBenchSheetDetectorSignal = {}; 

            //check if signals contains the new edit
            let matchingSignal = editedSignals.find(s => s.id === signalIdx);

            if (!matchingSignal) {
                let newSignal: HplcBenchSheetDetectorSignal = {
                    hplcBenchSheetDetectorId: detector.hplcBenchSheetDetectorId,
                    id: signalIdx,
                    signalValue: e.value,
                    isReference: e.event.data.prop === "0"
                }

                editedSignal = newSignal
            }
            else
                editedSignal = matchingSignal;

            editedSignal.signalValue = e.value;

            await updateDetectorSignal(editedSignal)
                .then(() => {
                    getDetector();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Detector Signal");
                });
        }
    }

    async function onDeleteDetectorClick(e: any) {
        if (props.hplcBenchSheetDetectorId) {
            await deleteDetector(props.hplcBenchSheetDetectorId)
                .then(() => {
                    //need to reload at parent
                    if (props.onDetectorDeleted)
                        props.onDetectorDeleted;
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Detector");
                });
        }
    }

    async function getDetector() {
        if (props.hplcBenchSheetDetectorId) {
            await CrudFunctions.getData(`benchsheets/hplcbenchsheetdetector/${props.hplcBenchSheetDetectorId}`)
                .then(data => {
                    setDetector(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Detectors");
                });
        }
    }

    async function updateDetectorSignal(signal: HplcBenchSheetDetectorSignal) {
        return CrudFunctions.putData("benchsheets/hplcdetectorsignal", signal);
    }

    // DELETE functions

    async function deleteDetector(detectorId: string) {
        return CrudFunctions.deleteData(`benchsheets/hplcbenchsheetdetector/${detectorId}`);
    }

    function onShowInformationDialogClick() {
        if (detector) {
            let itemBasicInformation: ItemBasicInformation = {
                rowPointer: detector.hplcBenchSheetDetectorId,
                createTimestamp: detector.createTimestamp,
                lastModifiedTimestamp: detector.modifyTimestamp,
                createUser: detector.createUser,
                modifyUser: detector.modifyUser
            };

            setItemBasicInformation(itemBasicInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    async function getAllData() {
        await getDetector();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
